import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[aaAutocompleteContent]',
    standalone: false
})
export class AutocompleteContentDirective
{
    constructor(public tpl: TemplateRef<any>)
    {
    }
}
